<template>
  <div>
    <users-setting/>
    <create-user
      :userScopes="adminScopes"
      @fetchUsersToTable="fetchUsersToTable"
    />
    <users-table
      :userScopes="adminScopes"
      @fetchUsersToTable="fetchUsersToTable"
      @handlePaginationChange="handlePaginationChange"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import stringCapitalize from '@/utils/helpers'
  import createUser from './createUser'
  import usersTable from './usersTable'
  import usersSetting from './usersSettings'

  export default {
    name: "Users",
    components: {createUser, usersTable, usersSetting},
    data () {
      return {
        page: 0,
        itemsOnPage: 10,
        search: '',
        filterEmail: '',
        filterUserName: ''
      }
    },
    computed: {
      ...mapGetters([
        'getIsSuperUser',
        'getIsMaster',
        'getUserRole'
      ]),
      adminScopes(){
        if (this.getIsSuperUser) return ['manager', 'master']
        if (this.getIsMaster) return ['manager']
        return []
      }
    },
    methods: {
      ...mapActions(['fetchUsers', 'fetchScopesList', 'fetchUsersForSuperAdmin']),
      stringCapitalize,
      async fetchUsersToTable(){
        let config = {page: this.page, itemsOnPage: this.itemsOnPage, userName: this.filterUserName, email: this.filterEmail}
        if (this.getIsSuperUser) {
          await this.fetchUsersForSuperAdmin(config)
        } else if (this.getIsMaster) {
          await this.fetchUsers(config)
        }
      },
      handlePaginationChange({page, itemsOnPage, userName, email}) {
        this.page = page
        this.itemsOnPage = itemsOnPage
        this.filterUserName = userName
        this.filterEmail = email
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/pages/Users/index.vue